// src/ExpertPayments.jsx

import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';

const summaryStats = [
  { label: 'Total Earnings', value: '₹32,450' },
  { label: 'Pending Payouts', value: '₹5,200' },
  { label: 'Completed Payouts', value: '₹27,250' },
  { label: 'Refunds Issued', value: '₹1,000' },
];

const transactions = [
  { id: '#T9821', client: 'Meet Shah', amount: '₹1200', date: '2024-06-15', status: 'Completed' },
  { id: '#T9820', client: 'Neha S.', amount: '₹500', date: '2024-06-14', status: 'Pending' },
  { id: '#T9819', client: 'Ajay R.', amount: '₹1500', date: '2024-06-13', status: 'Refunded' },
];

const statusColor = {
  Completed: 'text-green-600',
  Pending: 'text-yellow-600',
  Refunded: 'text-red-500',
};

const ExpertPayments = () => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-800">Payments</h1>
        <Button variant="outline">View Payout Settings</Button>
      </div>

      {/* Summary Cards */}
      <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-4">
        {summaryStats.map((item, i) => (
          <Card key={i} className="bg-white shadow-sm border">
            <CardContent className="py-6 text-center">
              <p className="text-2xl font-semibold">{item.value}</p>
              <p className="text-sm text-gray-500">{item.label}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Transactions Table */}
      <Card className="bg-white shadow-sm border">
        <CardContent className="py-6 overflow-x-auto">
          <h2 className="text-lg font-semibold mb-4">Recent Transactions</h2>
          <table className="min-w-full text-sm text-left border-collapse">
            <thead>
              <tr className="text-gray-600 border-b">
                <th className="pb-2">ID</th>
                <th className="pb-2">Client</th>
                <th className="pb-2">Amount</th>
                <th className="pb-2">Date</th>
                <th className="pb-2">Status</th>
              </tr>
            </thead>
            <tbody>
              {transactions.map((tx, i) => (
                <tr key={i} className="border-t">
                  <td className="py-2">{tx.id}</td>
                  <td className="py-2">{tx.client}</td>
                  <td className="py-2">{tx.amount}</td>
                  <td className="py-2">{tx.date}</td>
                  <td className={`py-2 font-medium ${statusColor[tx.status]}`}>
                    {tx.status}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>
  );
};

export default ExpertPayments;
